export default __webpack_public_path__ + "static/media/P-030.5f458955.png";